import { VirtualInboxDashboard } from "@/components/virtual-inbox/virtual-inbox-dashboard";
import { trpc } from "@/lib/trpc";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout/virtual-inbox")({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { data: project } = useSuspenseQuery(trpc.projects.getBySlug.queryOptions(params));

  return <VirtualInboxDashboard project={project} />;
}
